module.exports = __webpack_public_path__ + "static/disability_card_img1@2x-25f24db68d67129cf98571b540b882d2.jpg";